'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _storage = require('../storage');

var _storage2 = _interopRequireDefault(_storage);

var _agentUtils = require('./agent-utils');

var _agentUtils2 = _interopRequireDefault(_agentUtils);

var _trafficManager = require('../traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

var _lpMonitor = require('../live-person/lp-monitor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Source : Based off https://github.com/LivePersonInc/chat-js-sdk-sample-app/blob/master/script.js
// Documentation: https://developers.liveperson.com/javascript-chat-sdk-overview.html

var EventEmitter = require('events');
var appKey = '721c180b09eb463d9f3191c41762bb68';

/**
 * Live person connector that connects and manages events
 *
 * @class LiveConnection
 * @public
 */
var LiveConnection = function (_EventEmitter) {
  _inherits(LiveConnection, _EventEmitter);

  function LiveConnection(sessionId, logUrl) {
    _classCallCheck(this, LiveConnection);

    var _this = _possibleConstructorReturn(this, (LiveConnection.__proto__ || Object.getPrototypeOf(LiveConnection)).call(this));

    _this.engagementData = {};
    _this.engagementMaxRetries = 25;
    _this.engagementRetryTimeout = 100;
    _this.chat = null;
    _this.siteId = '';
    _this.skillName = '';
    _this.chatState = '';
    _this.sessionId = sessionId;
    _this.logUrl = logUrl;
    return _this;
  }

  _createClass(LiveConnection, [{
    key: 'getEngagementId',
    value: function getEngagementId() {
      return _storage2.default.getItem('rtSessionId');
    }
  }, {
    key: 'getSessionUID',
    value: function getSessionUID() {
      var sessionUID = _storage2.default.getItem('lpSessionUID');

      if (!sessionUID) {
        sessionUID = new Date().getTime();
        _storage2.default.setItem('lpSessionUID', sessionUID);
      }

      return sessionUID;
    }
  }, {
    key: 'getLastSequenceId',
    value: function getLastSequenceId() {
      return _storage2.default.getItem('lastSequenceId');
    }
  }, {
    key: 'setLastSequenceId',
    value: function setLastSequenceId(sequenceId) {
      _storage2.default.setItem('lastSequenceId', sequenceId);
    }

    /**
     * Initializes the connection with the agent.
     * @param {string} siteId for your account
     * @param {string} skillName is the skill we're routing the calls.
     * @param {Array} agentNotes is an array of customer and bot conversation in text format
     * @private
     */

  }, {
    key: 'initChat',
    value: function initChat(siteId, skillName) {
      var _this2 = this;

      this.siteId = siteId;
      this.skillName = skillName;
      var chatConfig = {
        lpNumber: siteId,
        appKey: appKey,
        sessionUID: this.getSessionUID(),
        onLoad: function onLoad(data) {
          _this2.emitEvt(data, 'onLoad');
        },
        onInit: function onInit(data) {
          _this2.chat.getEngagement();
          _this2.emitEvt(data, 'onInit');
        },
        onInfo: function onInfo(data) {
          var rtSessionId = _this2.getEngagementId();
          if (!rtSessionId) {
            _storage2.default.setItem('rtSessionId', data.rtSessionId);
            _storage2.default.setItem('lastEngagementId', data.rtSessionId);
          }
          _this2.emitEvt(data, 'onInfo');
        },
        onLine: function onLine(data) {
          _this2.emitEvt(data, 'onLine');
        },
        onState: function onState(data) {
          _this2.updateChatState(data);
          _this2.emitEvt(data, 'onState');
        },
        onStart: function onStart(data) {
          _this2.updateChatState(data);
          _this2.emitEvt(data, 'onStart');
        },
        onStop: function onStop(data) {
          _this2.updateChatState(data);
          _this2.emitEvt(data, 'onStop');
        },
        onAddLine: function onAddLine(data) {
          _this2.emitEvt(data, 'onAddLine');
        },
        onAgentTyping: function onAgentTyping(data) {
          _this2.emitEvt(data, 'onAgentTyping');
        },
        onRequestChat: function onRequestChat(data) {
          _this2.emitEvt(data, 'onRequestChat');
        },
        onVisitorDisposed: function onVisitorDisposed(data) {
          _this2.emitEvt(data, 'onVisitorDisposed');
        },
        onEngagement: function onEngagement(data) {
          _this2.handleEngagementResponse(data);
        }
      };

      var tData = [['skill', skillName || ''], ['session', this.getEngagementId() || '']];
      _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.chat.initchat', tData);
      this.chat = new window.lpTag.taglets.ChatOverRestAPI(chatConfig);
    }

    /**
     * @param {Object} data received from the onEngagement event
     * Handles the engagement response and retries engagement eligibility on failure
     * @private
     */

  }, {
    key: 'handleEngagementResponse',
    value: function handleEngagementResponse(data) {
      var tData = [['session', this.getEngagementId() || ''], ['status', data.status || ''], ['maxRetries', this.engagementMaxRetries]];
      _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.chat.engagementresponse', tData);

      if (data.status === 'Available') {
        this.engagementData = data;
        this.emitEvt(data, 'onEngagement');
      } else if (this.engagementMaxRetries > 0) {
        window.setTimeout(this.getEngagement, this.engagementRetryTimeout);
        this.engagementMaxRetries--;
      } else {
        if (!data.error) {
          data.error = {
            reason: 'cannot get the engagment with live person'
          };
        }
        this.emitEvt(data, 'onError');
      }
    }

    /**
     * @returns {Object} the instatiated chat object
     * @private
     */

  }, {
    key: 'getChat',
    value: function getChat() {
      return this.chat;
    }

    /**
     * @param {string} data for the event
     * @param {string} event name
     * Emits events back to the listener
     * @private
     */

  }, {
    key: 'emitEvt',
    value: function emitEvt(data, event) {
      var loggedEvent = event || 'undefined';
      var tData = [['session', this.getEngagementId() || '']];
      if (data && data.error) {
        _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.chat.emitevent.' + loggedEvent, tData.concat([['error', 'true'], ['reason', data.error.reason || '']]));
        data.event = 'onError';
        this.emit('onError', data);
        this.endChat();
      } else {
        _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.chat.emitevent.' + loggedEvent, tData);
        data.event = event;
        this.emit(event, data);
      }
    }

    /**
     * Executes engagements eligibility and availability check.
     * @private
     */

  }, {
    key: 'getEngagement',
    value: function getEngagement() {
      if (this.chat) {
        this.chat.getEngagement();
      }
    }

    /**
     * Queues the chat request with the live person.
     * @param {Array} agentNotes is an array of customer and bot conversation in text format
     * @private
     */

  }, {
    key: 'startChat',
    value: function startChat(agentNotes) {
      var _this3 = this;

      var rtSessionId = this.getEngagementId();
      if (rtSessionId) {
        this.chat.reInit();
      } else {
        var failedRequest = this.chat.requestChat({
          LETagVisitorId: this.engagementData.svid,
          LETagSessionId: this.engagementData.ssid,
          LETagContextId: this.engagementData.scid,
          skill: this.skillName,
          engagementId: this.engagementData.eid,
          campaignId: this.engagementData.cid,
          language: this.engagementData.lang,
          preChatLines: agentNotes || [],
          success: function success() {},
          error: function error(_error) {
            (0, _lpMonitor.notify)('onErrorOther', { error: _error, info: 'requestChat error callback' }, _this3.sessionId, _this3.logUrl);
          }
        });

        if (failedRequest && failedRequest.error) {
          (0, _lpMonitor.notify)('onErrorOther', { error: failedRequest.error, info: 'requestChat failed request' }, this.sessionId, this.logUrl);
        }
      }
    }

    /**
     * sends the chat line to the live person agent
     * @param {string} text to send to the agent.
     * @private
     */

  }, {
    key: 'sendConversation',
    value: function sendConversation(text) {
      var _this4 = this;

      if (text && this.chat) {
        var failedRequest = this.chat.addLine({
          text: text,
          error: function error(_error2) {
            (0, _lpMonitor.notify)('onErrorOther', { error: _error2, info: 'addLine error callback' }, _this4.sessionId, _this4.logUrl);
          }
        });

        if (failedRequest && failedRequest.error) {
          (0, _lpMonitor.notify)('onErrorOther', { error: failedRequest.error, info: 'addLine failed request' }, this.sessionId, this.logUrl);
        }
      }
    }

    /**
     * clears the session storage
     * @private
     */

  }, {
    key: 'clearStorage',
    value: function clearStorage() {
      var _this5 = this;

      ['lpVisitorChatRels', 'lpVisitorResumeMode', 'lpTabId', 'lpVisitorSessionVars'].forEach(function (item) {
        _storage2.default.removeItem(item + _this5.siteId);
      });
      _storage2.default.removeItem('lpTabId');
      _storage2.default.removeItem('lpSessionUID');
      _storage2.default.removeItem('rtSessionId');
      _storage2.default.removeItem('lastSequenceId');
    }

    /**
     * Notify the agent that the visitor has ended the chat.
     * @private
     */

  }, {
    key: 'endChat',
    value: function endChat() {
      var _this6 = this;

      if (this.chat) {

        window.localStorage.removeItem('liveEngageChatId');

        var failedRequest = this.chat.endChat({
          context: this.chat,
          disposeVisitor: true,
          success: function success() {
            _this6.dispose();
          },
          error: function error(_error3) {
            (0, _lpMonitor.notify)('onErrorOther', { error: _error3, info: 'endchat error callback' }, _this6.sessionId, _this6.logUrl);
          }
        });

        if (failedRequest && failedRequest.error) {
          (0, _lpMonitor.notify)('onErrorOther', { error: failedRequest.error, info: 'endChat failed request' }, this.sessionId, this.logUrl);
        }
      }
      this.clearStorage();
    }

    /**
     * disposes the state of the connection
     * @private
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      this.chat = null;
      this.updateChatState('ended');
    }

    /**
     * sets the current chat state
     * @param {Object} data from the event received
     * @private
     */

  }, {
    key: 'updateChatState',
    value: function updateChatState(data) {
      // When chatState changes, we can set the agent info in storage
      if (this.chat) {
        _agentUtils2.default.setAgentInfo({
          id: this.chat.getAgentId(),
          name: this.chat.getAgentLoginName()
        });
      }

      if (data.state === 'ended' && this.chatState !== 'ended') {
        this.chat.disposeVisitor();
      }

      this.chatState = data.state;
    }
  }]);

  return LiveConnection;
}(EventEmitter);

exports.default = LiveConnection;